import React from 'react';

import styles from './RatingTable.module.scss';

const data = [
  {
    id: 0,
    type: 'Corporate Ratings:',
    dataType: 'title',
  },
  {
    id: 1,
    type: 'HSE Investment S.à r.l.',
    agency: `Fitch`,
    rating: 'B-',
    outlook: 'stable',
    date: 'August 18, 2026',
  },
  {
    id: 2,
    type: 'HSE Finance S.à r.l.',
    agency: 'S&P Global',
    rating: 'B-',
    outlook: 'stable',
    date: 'August 21, 2026',
  },
  {
    id: 3,
    type: 'Instrument Ratings:',
    dataType: 'title',
  },
  {
    id: 4,
    type: 'HSE Investment S.à r.l. — Senior Secured Notes',
    agency: `Fitch`,
    rating: 'B-',
    outlook: '',
    date: 'August 18, 2026',
  },
  {
    id: 5,
    type: 'HSE Investment S.à r.l. — Senior Secured Notes',
    agency: 'S&P Global',
    rating: 'B-',
    outlook: '',
    date: 'August 21, 2026',
  },
];

const RatingTable = () => {
  return (
    <div className={styles.wrapper} id="rating">
      <h2>Ratings</h2>
      <table>
        <thead>
          <tr>
            <th>&nbsp;</th>
            <th>Agency</th>
            <th>Rating</th>
            <th>Outlook</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {data.map(({ id, type, agency, rating, outlook, date, dataType = '' }) => {
            if (dataType === 'title') {
              return (
                <tr className="key" key={id}>
                  <td
                    style={{
                      fontSize: '18px',
                      fontWeight: 'bold',
                      display: 'block',
                      paddingTop: '22px',
                      paddingBottom: '12px',
                    }}
                  >
                    {type}
                  </td>
                </tr>
              );
            }
            return (
              <tr className="key" key={id}>
                <td>{type}</td>
                <td>{agency}</td>
                <td>{rating}</td>
                <td>{outlook}</td>
                <td>{date}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default RatingTable;
